import React from "react";
import Grid from "@mui/material/GridLegacy";
import { CustomText } from "../";
import { fonts } from "../../config";
import styled from "styled-components";

const Line = styled.div({
  width: "100%",
  height: "1px",
  backgroundColor: "#E4E6E8",
  marginTop: "6px",
});

interface ReadOnlyFieldProps {
  md?: number;
  label: string;
  value?: React.ReactNode;
}

function ReadOnlyField({ md = 6, label, value }: ReadOnlyFieldProps) {
  return (
    <Grid item xs={12} md={md}>
      <CustomText
        fontSize={1.75}
        fontFamily={fonts.semibold}
        textColor="#4D585A"
        style={{ paddingBottom: "6px" }}
      >
        {label}
      </CustomText>
      <CustomText
        fontSize={2}
        fontFamily={fonts.semibold}
        textColor="#24272A"
        style={{ paddingBottom: "6px" }}
      >
        {value}
      </CustomText>
      <Line />
    </Grid>
  );
}

export default ReadOnlyField;
